import { baseUrl, headers } from "./config";
import { fetchAndParse } from "./utils";
export function getApiHealth(): Promise<string> {
    const url = new URL(`/api/health`, baseUrl);
    return fetchAndParse<string>(url.toString(), { method: "GET", headers });
}
